import { Outlet, useNavigate } from "react-router-dom"
import { useUserStore } from '../../store/user.store'
import { observer } from "mobx-react"
import { useEffect, useState } from "react"
import { Box, Button, CircularProgress, Paper, Typography } from "@mui/material"
import warningImg from '../../../shared/assets/access-denied.svg'
import alivelogo from '../../../shared/assets/alivelogo.png'
import noConnectionImg from '../../../shared/assets/no-connection.svg'
import serverDownImg from '../../../shared/assets/server-down.svg'
import { useSettingsStore } from "../../store/settings.store"
import { LoginOutlined } from "@mui/icons-material"
import { ERPLoginPageURL } from '../../../shared/utils/constants.jsx'

const RequireAuditAccess = observer( ( { allowedRoles } ) => {

    const [errorCode, setErrorCode] = useState( null )
    const [loading, setLoading] = useState( true )

    const SettingsStore = useSettingsStore()
    const UserStore = useUserStore()
    const navigate = useNavigate()

    const navigateToSignin = () => {
        const redirectValue = encodeURIComponent( `${window.location.pathname}${window.location.search}` )
        if ( ['admin', 'subadmin'].includes( UserStore?.getUser?.user_role?.toLowerCase() ) )
            navigate( `/admin?redirect=${redirectValue}` )
        else
            window.location.href = `${ERPLoginPageURL}?redirect=${redirectValue}`
    }

    useEffect( () => {
        const getUser = async () => {
            const { netError } = await UserStore.fetchUser()
            if ( netError ) {
                const internetConnected = window.navigator.onLine
                if ( !internetConnected )
                    setErrorCode( "noInternet" )
                else
                    setErrorCode( "serverConnectionError" )
            } else
                await SettingsStore.fetchSettings( { filter: 'foruse' } )
            setLoading( false )
        }
        getUser()
    }, [UserStore, SettingsStore] )

    return (loading ? <Box
        sx={{
            display: "flex",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            background: `url('/imgs/bg-pattern1.png')`
        }}>
        <Paper sx={{ minWidth: "220px", padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
            <img width="70px" src={alivelogo} alt="Alive" />
            <Typography
                variant="subtitle2"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}> <CircularProgress size={14} /> Loading Alive...</Typography>
        </Paper>
    </Box> : errorCode ? <Box
        sx={{
            display: "flex",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            background: `url('/imgs/bg-pattern1.png')`
        }}>
            {errorCode === "noInternet" && <Paper sx={{ minWidth: "220px", padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
                <img width="70px" src={noConnectionImg} alt="Alive" />
                <Typography
                    variant="subtitle2"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                    }}> Check your intenet connection</Typography>
            </Paper>}
            {errorCode === "serverConnectionError" && <Paper sx={{ minWidth: "220px", padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
                <img width="150px" src={serverDownImg} alt="Alive" />
                <Typography
                    variant="subtitle2"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                    }}> Server cannot be reached! try again later</Typography>
            </Paper>}
        </Box> :
            ( ( allowedRoles.includes( UserStore.getUser['user_role'].toUpperCase() ) || allowedRoles.includes( 'is_auditor ' ) ) && ( UserStore.getUser['user_role'].toUpperCase() !== 'SUBADMIN' || ( UserStore.getUser['user_role'].toUpperCase() === 'SUBADMIN' && UserStore.getUser?.user_permissions?.auditing === true ) ) )
                ? <Outlet />
                : <Box
                sx={{
                    padding: "20px",
                    height: "calc(100% - 40px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: `url('/imgs/bg-pattern1.png')`
                }}>
                    <Paper sx={{ display: "flex", padding: "40px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", flexDirection: "column", justifyContent: "center", gap: "20px", alignItems: "center", borderRadius: "5px" }}>
                        <img width="200px" src={warningImg} alt="session ended" />
                        <Typography variant="subtitle2" sx={{
                            textAlign: "center"
                        }} >
                            You are not allowed to access this page. this pages if only available for <em>{allowedRoles.join( ", " )} and auditor.</em>
                        </Typography>
                        {UserStore.getUser.user_role === 'SUBADMIN' && <Typography
                            variant="subtitle2"
                            sx={{
                                fontSize: "10px",
                                textAlign: "center"
                            }}>
                            Subadmins only with auditing access can access the auditing pages.
                        </Typography>}
                        <Button variant="outlined" startIcon={<LoginOutlined />} color="primary" onClick={navigateToSignin} sx={{ textTransform: "capitalize" }}>Sign in</Button>
                    </Paper>
                </Box>);
} )

export default RequireAuditAccess
